import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './recipes.css';
import RecipeCreator from './RecipeCreator';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RecipeCreator />
  </React.StrictMode>
);